import Router from '../router';
import ls from 'local-storage';
import store from '../store';

/**
* Global API methods
*/
function getResource(url, query) {
    return new Promise((resolve, reject) => {
        fetch(`${store.getters.getApi}${url}${query ? `?${query}` : ''}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${ls.get('GEG__KEY')}`,
            }
        })
            .then(res => {
              if (res.status === 200) return res.json();
              return reject(res);
            })
            .then(res => resolve(res))
            .catch(error => reject(error));
    });
}

function postResource(url, query, body) {
    return new Promise((resolve, reject) => {
        fetch(`${store.getters.getApi}${url}${query ? `?${query}` : ''}`, {
            'method': 'POST',
            'headers': {
                'Authorization': `Bearer ${ls.get('GEG__KEY')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            'body': JSON.stringify(body),
        })
            .then(res => res.json())
            .then((res) => {
                if (res.status === 'success') return resolve(res);
                return reject(res);
            })
            .catch(error => reject(error));
    });
}

function postImage(url, query, body) {
    const formData = new FormData();
    formData.append('file', body);
    return new Promise((resolve, reject) => {
        fetch(`${store.getters.getApi}${url}${query ? `?${query}` : ''}`, {
            'method': 'POST',
            'headers': {
                'Authorization': `Bearer ${ls.get('GEG__KEY')}`

            },
            'body': formData,
        })
            .then(res => res.json())
            .then((res) => {
                if (res.status === 'success') return resolve(res);
                return reject(res);
            })
            .catch(error => reject(error));
    });
}

export {
  getResource,
  postResource,
  postImage
};



// WEBPACK FOOTER //
// ./src/services/Utils.js